import { render, staticRenderFns } from "./ConfirmPaymentOrder.vue?vue&type=template&id=1b25ecc4&"
import script from "./ConfirmPaymentOrder.vue?vue&type=script&lang=js&"
export * from "./ConfirmPaymentOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports